import { render, staticRenderFns } from "./double.vue?vue&type=template&id=7ecbaf00&scoped=true&"
import script from "./double.vue?vue&type=script&lang=js&"
export * from "./double.vue?vue&type=script&lang=js&"
import style0 from "./double.vue?vue&type=style&index=0&id=7ecbaf00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecbaf00",
  null
  
)

export default component.exports